import React from 'react';

const WORK_PHOTOS = [
  { src: '/20260528_205842_255_3600.jpg', alt: 'Guests posing with props in the booth' },
  { src: '/20260528_210103_858_3600.jpg', alt: 'Family portrait taken in the booth' },
  { src: '/20260528_211241_869_3600.jpg', alt: 'Wedding guests posing together' },
  { src: '/20260528_213126_496_3600.jpg', alt: 'Group of friends with feather boas and props' },
  { src: '/20260528_220411_301_3600.jpg', alt: 'Large group squeezing into the frame' },
  { src: '/20260528_221212_606_3600.jpg', alt: 'Guests pulling faces for the camera' },
];

const OurWork = () => {
  return (
    <section className="our-work" id="our-work">
      <h2 className="our-work-title">Our Work</h2>
      <div className="our-work-grid">
        {WORK_PHOTOS.map((photo) => (
          <div className="our-work-item" key={photo.src}>
            <img src={photo.src} alt={photo.alt} loading="lazy" decoding="async" />
          </div>
        ))}
      </div>

      <div className="our-work-cta">
        <a
          href="https://fotoshare.co/e/S3vH9oxpzOewNSc4GBLt4"
          className="offering-feature-btn"
          data-track="home_our_work"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Full Gallery <span aria-hidden="true">&rarr;</span>
        </a>
      </div>
    </section>
  );
};

export default OurWork;
